(function () {
    'use strict';

    angular.module("imApp").factory("visitorService", ['$ihttp', function ($ihttp) {
        let service = {
            listFindPersons: function (parms) {
                return $ihttp.post({
                    method: 117,
                    parameters: parms || {}
                });
            },
            listVisitorOuts: function (parms) {
                return $ihttp.post({
                    method: 120,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
